export default __webpack_public_path__ + "ea6d860317e1e65326a731dadfd2f509.png";